/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-11-04 17:31:03
 */
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/lib/notification'
import urlConfig from '@/config/url.config.js'
import { getCookie } from '@/utils/util.js'
import localstorage from '@/localstorage'

// 创建 axios 实例
const service = axios.create({
  // 判断环境不是 prod 或者 preview 是 true 时，加载 mock 服务
  baseURL: process.env.EVN_CONFIG !== 'prod' ? urlConfig.dev_api : urlConfig.prod_api, // api base_url
  timeout: 5000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const token = getCookie('token')
    if (error.response.status === 403) {
      // notification.error({ message: '禁止访问', description: data.message})
    }
    if (error.response.status === 401) {
      notification.error({ message: '登录信息已过期', description: '请重新登录' })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }else{
        window.location.reload()
      }
    }
  }
  return Promise.reject(error)
}


// request interceptor
service.interceptors.request.use(config => {
  const token = getCookie('token')
  const orgls = localstorage.getLocalStorage('pro__ORG')||{}
  const org = orgls.value
  if (token) {
    config.headers['authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (!config.noOrg&&org){
    config.headers['X-Current-Org'] = org.id||''
  }
  // config.headers['X-User-Id'] = '5de755e0eb9da1000a000000'
  // config.headers['X-Roleperm-Scopes'] = 'all'
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  const res = response.data;
  //blob类型为文件下载对象，不论是什么请求方式，直接返回文件流数据
  if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {  //下载excel类型
    let blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    let downloadElement = document.createElement('a');
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    //获取文件名
    let fileName = decodeURI(response.headers['content-disposition'].split("=")[1]);  //处理文件名乱码问题
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    return fileName
  }
  return res
}, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}


// WEBPACK FOOTER //
// ./src/utils/request.js